import React, { Suspense } from "react"; 
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './i18n';

import log from "./utils/logger";
import { registerServiceWorker } from "./services/push";

if (process.env.NODE_ENV === "development") {
  log.setLevel("debug");
} else {
  log.setLevel("warn");
}

const isDevelopment = process.env.REACT_APP_ENV === "development";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback="Loading..."> 
      <BrowserRouter>
        <App isDevelopment={isDevelopment} />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// Registers the service worker: this is what lets the browser offer "Install
// Glonet" (an icon on the dock / home screen) and what receives web push.
// Deliberately after load — it must never compete with first paint. Guarded on
// readyState because a cached bundle can finish loading before this line runs,
// and a missed 'load' event would mean the worker silently never registers.
if (document.readyState === "complete") {
  registerServiceWorker();
} else {
  window.addEventListener("load", () => { registerServiceWorker(); });
}

reportWebVitals();
